<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible="visible"
      :title="title || '样品对应的产品特性信息'"
      direction="rtl"
      :size="899"
      @close="$refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          :samplePropertiesImageCode="samplePropertiesImageCode"
          @close="close()"
        />
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    samplePropertiesImageCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      if (!this.disabled) this.$emit('reload')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 32px;
}
</style>
